import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useRef, useState } from 'react';
import { connectSocket, disconnectSocket, getSocket, onSocketAgentNotification, onSocketConnect, onSocketDisconnect, onSocketError, onSocketMessage, onSocketReconnect } from '../../utils/socket';
var DEFAULT_CONNECT_TIMEOUT = 30000;
export var useSocketChatConnect = function useSocketChatConnect() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onConnectSuccess = props.onConnectSuccess,
      onConnectError = props.onConnectError,
      onDisconnect = props.onDisconnect,
      onReceiveMessage = props.onReceiveMessage,
      onReconnect = props.onReconnect,
      onReceiveSocketAckMessage = props.onReceiveSocketAckMessage,
      onReceiveAgentNotificationMessage = props.onReceiveAgentNotificationMessage;

  var _useState = useState(false),
      isSocketConnecting = _useState[0],
      setIsSocketConnecting = _useState[1];

  var _useState2 = useState(''),
      socketConnectErrorMessage = _useState2[0],
      setSocketConnectErrorMessage = _useState2[1];

  var _useState3 = useState(0),
      pendingSocketAckCount = _useState3[0],
      setPendingSocketAckCount = _useState3[1];

  var socketEventsCleanupRef = useRef(void 0);
  var pendingAckRequestIdSetRef = useRef(new Set());
  var socketConnectData = useRef(null);
  var onConnectSuccessRef = useRef(onConnectSuccess);
  var onConnectErrorRef = useRef(onConnectError);
  var onDisconnectRef = useRef(onDisconnect);
  var onReceiveMessageRef = useRef(onReceiveMessage);
  var onReconnectRef = useRef(onReconnect);
  var onReceiveSocketAckMessageRef = useRef(onReceiveSocketAckMessage);
  var onReceiveAgentNotificationMessageRef = useRef(onReceiveAgentNotificationMessage);
  /**
   * effects
   */

  useEffect(function () {
    return function () {
      cleanSocketAckReleateInfo();
      cleanSocketReleateInfo();
    };
  }, []);
  useEffect(function () {
    onConnectSuccessRef.current = onConnectSuccess;
    onConnectErrorRef.current = onConnectError;
    onDisconnectRef.current = onDisconnect;
    onReceiveMessageRef.current = onReceiveMessage;
    onReconnectRef.current = onReconnect;
    onReceiveSocketAckMessageRef.current = onReceiveSocketAckMessage;
    onReceiveAgentNotificationMessageRef.current = onReceiveAgentNotificationMessage;
  }, [onConnectSuccess, onConnectError, onDisconnect, onReceiveMessage, onReconnect, onReceiveSocketAckMessage, onReceiveAgentNotificationMessage]);
  /**
   * methods
   */

  var cleanSocketAllInfo = function cleanSocketAllInfo() {
    cleanSocketAckReleateInfo();
    cleanSocketReleateInfo();
  };

  var cleanSocketAckReleateInfo = function cleanSocketAckReleateInfo() {
    pendingAckRequestIdSetRef.current.clear();
    setPendingSocketAckCount(0);
  };

  var cleanSocketReleateInfo = function cleanSocketReleateInfo() {
    var _socketEventsCleanupR;

    disconnectSocket();
    (_socketEventsCleanupR = socketEventsCleanupRef.current) === null || _socketEventsCleanupR === void 0 ? void 0 : _socketEventsCleanupR.call(socketEventsCleanupRef);
    socketEventsCleanupRef.current = void 0;
  };

  var initSocketConnectionWithConfig = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var socket;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cleanSocketAckReleateInfo();
              cleanSocketReleateInfo();
              socket = connectSocket(_objectSpread({}, socketConnectData.current));

              if (socket) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", null);

            case 5:
              return _context.abrupt("return", new Promise(function (resolve) {
                var _socketConnectData$cu, _socketConnectData$cu2;

                var hasResolved = false;
                var timeoutHandler = null;

                var resolveOnce = function resolveOnce(isSuccess) {
                  if (hasResolved) {
                    return;
                  }

                  hasResolved = true;

                  if (isSuccess) {
                    resolve(cleanup);
                    return;
                  }

                  cleanup();
                  disconnectSocket();
                  resolve(null);
                };

                var offConnect = onSocketConnect(function () {
                  var _onConnectSuccessRef$;

                  (_onConnectSuccessRef$ = onConnectSuccessRef.current) === null || _onConnectSuccessRef$ === void 0 ? void 0 : _onConnectSuccessRef$.call(onConnectSuccessRef);
                  resolveOnce(true);
                });
                var offMessage = onSocketMessage(function (payload) {
                  var _onReceiveMessageRef$;

                  (_onReceiveMessageRef$ = onReceiveMessageRef.current) === null || _onReceiveMessageRef$ === void 0 ? void 0 : _onReceiveMessageRef$.call(onReceiveMessageRef, payload);
                });
                var offAgentNotification = onSocketAgentNotification(function (payload) {
                  var _onReceiveAgentNotifi;

                  (_onReceiveAgentNotifi = onReceiveAgentNotificationMessageRef.current) === null || _onReceiveAgentNotifi === void 0 ? void 0 : _onReceiveAgentNotifi.call(onReceiveAgentNotificationMessageRef, payload);
                });
                var offReconnect = onSocketReconnect(function (payload) {
                  var _onReconnectRef$curre;

                  (_onReconnectRef$curre = onReconnectRef.current) === null || _onReconnectRef$curre === void 0 ? void 0 : _onReconnectRef$curre.call(onReconnectRef, payload);
                });
                var offDisconnect = onSocketDisconnect(function (reason) {
                  var _onDisconnectRef$curr;

                  (_onDisconnectRef$curr = onDisconnectRef.current) === null || _onDisconnectRef$curr === void 0 ? void 0 : _onDisconnectRef$curr.call(onDisconnectRef, reason);
                });
                var offError = onSocketError(function (error) {
                  var _onConnectErrorRef$cu;

                  (_onConnectErrorRef$cu = onConnectErrorRef.current) === null || _onConnectErrorRef$cu === void 0 ? void 0 : _onConnectErrorRef$cu.call(onConnectErrorRef, error);
                  resolveOnce(false);
                });
                timeoutHandler = setTimeout(function () {
                  resolveOnce(false);
                }, (_socketConnectData$cu = (_socketConnectData$cu2 = socketConnectData.current) === null || _socketConnectData$cu2 === void 0 ? void 0 : _socketConnectData$cu2.connectTimeout) !== null && _socketConnectData$cu !== void 0 ? _socketConnectData$cu : DEFAULT_CONNECT_TIMEOUT);

                var cleanup = function cleanup() {
                  offConnect();
                  offMessage();
                  offAgentNotification();
                  offReconnect();
                  offDisconnect();
                  offError();

                  if (timeoutHandler) {
                    clearTimeout(timeoutHandler);
                    timeoutHandler = null;
                  }
                };
              }));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function initSocketConnectionWithConfig() {
      return _ref.apply(this, arguments);
    };
  }();

  var ensureSocketConnected = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, config) {
      var cleanupSocketEvents;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (data) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", false);

            case 2:
              setIsSocketConnecting(true);
              setSocketConnectErrorMessage('');
              socketConnectData.current = data;
              _context2.next = 7;
              return initSocketConnectionWithConfig();

            case 7:
              cleanupSocketEvents = _context2.sent;
              setIsSocketConnecting(false);

              if (cleanupSocketEvents) {
                _context2.next = 12;
                break;
              }

              setSocketConnectErrorMessage((config === null || config === void 0 ? void 0 : config.errorMessage) || 'Connection failed.');
              return _context2.abrupt("return", false);

            case 12:
              socketEventsCleanupRef.current = cleanupSocketEvents;
              return _context2.abrupt("return", true);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function ensureSocketConnected(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var isSocketConnected = function isSocketConnected() {
    var socket = getSocket();
    return Boolean(socket === null || socket === void 0 ? void 0 : socket.connected);
  };

  return {
    isSocketConnecting: isSocketConnecting,
    socketConnectErrorMessage: socketConnectErrorMessage,
    pendingSocketAckCount: pendingSocketAckCount,
    ensureSocketConnected: ensureSocketConnected,
    cleanSocketReleateInfo: cleanSocketReleateInfo,
    cleanSocketAckReleateInfo: cleanSocketAckReleateInfo,
    isSocketConnected: isSocketConnected,
    pendingAckRequestIdSetRef: pendingAckRequestIdSetRef,
    setPendingSocketAckCount: setPendingSocketAckCount,
    cleanSocketAllInfo: cleanSocketAllInfo
  };
};